import './components/table/editors';
import './components/table/renderers';
import './static/style/_all.scss';

import { components } from './components';
import detailsHelper from './helpers/detailsHelper';
import filtersHelper from './helpers/filtersHelper';
import tableHelper from './helpers/tableHelper';
import { SessionSettingsService } from './services/sessionSettingsService';
import { UploadManager } from './services/uploadManager';
import { UserSettingsService } from './services/userSettingsService';
import {
  NAMESPACE as SESSION_SETTINGS_NAMESPACE,
  SessionSettingsModule,
} from './store/sessionSettings';
import { NAMESPACE as USER_SETTINGS_NAMESPACE, UserSettingsModule } from './store/userSettings';

/**
 * Function to install module in Vue instance
 * @params {Object} Vue: Vue instance
 * @params {Object} settings: object who contains router and store instance
 * */
export function install(Vue, settings) {
  for (const component of components) {
    Vue.component(component.name, component);
  }
  if (!settings || !settings.store || !settings.router || !settings.services || !settings.helpers) {
    throw new Error(
      'Please initialise plugin with a Vuex store, a Vue router a PiivoServices and a PiivoHelpers.'
    );
  }
  if (settings.store.state[USER_SETTINGS_NAMESPACE]) {
    settings.store.registerModule(USER_SETTINGS_NAMESPACE, UserSettingsModule, {
      preserveState: true,
    });
  } else {
    settings.store.registerModule(USER_SETTINGS_NAMESPACE, UserSettingsModule);
  }
  if (settings.store.state[SESSION_SETTINGS_NAMESPACE]) {
    settings.store.registerModule(SESSION_SETTINGS_NAMESPACE, SessionSettingsModule, {
      preserveState: true,
    });
  } else {
    settings.store.registerModule(SESSION_SETTINGS_NAMESPACE, SessionSettingsModule);
  }

  /* Install services */
  settings.services.addService('uploadManager', UploadManager);
  settings.services.addService('userSettings', new UserSettingsService());
  settings.services.addService('sessionSettings', new SessionSettingsService());

  /* Install helpers */
  settings.helpers.addHelper('detailsHelper', detailsHelper);
  settings.helpers.addHelper('filtersHelper', filtersHelper);
  settings.helpers.addHelper('tableHelper', tableHelper);
}

export default install;
